export default __webpack_public_path__ + "static/media/run.d5fae18b.svg";